/**
 * @description Check for UTM params and returns it // https://en.wikipedia.org/wiki/UTM_parameters
 *
 * @param {boolean} object if need return value as object
 * @returns {string} url params
 */
function GetUTMParams( object = false ) {
	let urlParams = "";
	let utm_source = getUrlParam( "utm_source", 0 ) || getCookie( "utm_source" ) || "";
	if ( utm_source ) {
		urlParams += "&utm_source=" + utm_source;
	}
	let utm_medium = getUrlParam( "utm_medium", 0 ) || getCookie( "utm_medium" ) || "";
	if ( utm_medium ) {
		urlParams += "&utm_medium=" + utm_medium;
	}
	let utm_campaign = getUrlParam( "utm_campaign", 0 ) || getCookie( "utm_campaign" ) || "";
	if ( utm_campaign ) {
		urlParams += "&utm_campaign=" + utm_campaign;
	}
	// do not delete it may be needed
	// let utm_term = getUrlParam( "utm_term", 0 ) || getCookie( "utm_term" );
	// if ( utm_term ) {
	//     urlParams += "&utm_term=" + utm_term;
	// }
	// let utm_content = getUrlParam( "utm_content", 0 ) || getCookie( "utm_content" );
	// if ( utm_content ) {
	//     urlParams += "&utm_content=" + utm_content;
	// }

	if ( object === true ) {
		return {
			utm_source: utm_source,
			utm_medium: utm_medium,
			utm_campaign: utm_campaign
			// utm_term: utm_term,
			// utm_content: utm_content
		};
	}

	return urlParams;
}

/**
 * @returns {string} params from url
 */
function getUrlVars() {
	var vars = {};
	var parts = window.location.href.replace( /[?&]+([^=&]+)=([^&]*)/gi, function ( m, key, value ) {
		vars[ key ] = value;
	} );
	return vars;
}

/**
 * @description get query param by name
 *
 * @param {string} parameter name of parameter
 * @param {string} defaultvalue set default return value
 * @returns {string} param value
 */
function getUrlParam( parameter, defaultvalue ) {
	var urlparameter = defaultvalue;
	if ( window.location.href.indexOf( parameter ) > -1 ) {
		urlparameter = getUrlVars()[ parameter ];
	}
	return urlparameter;
}

/**
 * @param {string} name cookie name
 * @returns {string} cookie value
 */
function getCookie( name ) {
	const value = `; ${ document.cookie }`;
	const parts = value.split( `; ${ name }=` );
	if ( parts.length === 2 ) {
		return parts.pop().split( ";" ).shift();
	}
	return false;
}

export { GetUTMParams };